import { useOutletContext } from 'react-router';
import type { Fund } from '@/types/fund';

export interface FundLayoutContext {
  fund: Fund;
  fundId: string;
}

export function useFundLayoutContext() {
  return useOutletContext<FundLayoutContext>();
}
